/**********************************************************************
 *
 * Copyright (C) 2026 Almendo Technologies GmbH
 * Copyright (C) 2026 Marcus Harringer
 *
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of
 * Marcus Harringer. The intellectual and technical concepts contained
 * herein are proprietary to Marcus Harringer and may be covered
 * copyright law. Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written permission
 * is obtained from Marcus Harringer.
 *
 ***********************************************************************/
import { Amplify } from 'aws-amplify';
import awsExportsApp from './aws-exports-app';

// Configured once, before any module of the app is evaluated: index.js imports this file first
Amplify.configure(awsExportsApp);
